import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Typography,
  Toolbar,
  Fab,
  ThemeProvider,
} from "@material-ui/core";
import * as React from "react";
import AddIcon from "@material-ui/icons/Add";
import { defaultTheme } from "../utils/theme";
import HasMutablePermission from "../auth/HasMutablePermission";
import { AuthConsumer } from "../routes/AuthContext";
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3,
    },
    button: {
      margin: theme.spacing(1),
      width: "20%",
      height: 48,
    },
    menuButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "none",
      },
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    large: {
      margin: 10,
      width: theme.spacing(15),
      height: theme.spacing(15),
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
  });
interface Props extends WithStyles<typeof styles> {
  title: any;
  buttonTitle: any;
  onToolBarButtonClicked?: any;
  menuButtonRender?: any;
  additionalButton?: any;
}
class ToolBarComponent extends React.Component<Props> {
  state = {
    mobileOpen: false,
  };
  handleDrawerToggle = () => {
    this.setState({ mobileOpen: true });
  };

  hasPermission = (title: any, user: any, accessRules: any) => {
    if (title.toUpperCase() === "COMPANIES") {
      return HasMutablePermission({
        role: user.role,
        accessRules: accessRules,
        perform: "companies:add",
      });
    }
    if (title.toUpperCase() === "EMPLOYEES") {
      return HasMutablePermission({
        role: user.role,
        accessRules: accessRules,
        perform: "company-employees:create",
      });
    }
    if (title.toUpperCase() === "INSPECTIONS") {
      return HasMutablePermission({
        role: user.role,
        accessRules: accessRules,
        perform: "company-inspections:create",
      });
    }
    if (title.toUpperCase() === "EQUIPMENTS") {
      return HasMutablePermission({
        role: user.role,
        accessRules: accessRules,
        perform: "company-equipments:create",
      });
    }
    if (title.toUpperCase() === "COMPLETED") {
      return HasMutablePermission({
        role: user.role,
        accessRules: accessRules,
        perform: "company-completed:import",
      });
    }
    if (title.toUpperCase() === "VISITORS") {
      return HasMutablePermission({
        role: user.role,
        accessRules: accessRules,
        perform: "company-visitors:create",
      });
    }
    if (title.toUpperCase() === "EQUIPMENTS") {
      return HasMutablePermission({
        role: user.role,
        accessRules: accessRules,
        perform: "company-equipment:create",
      });
    }
  };

  render() {
    const {
      classes,
      title,
      menuButtonRender,
      buttonTitle,
      onToolBarButtonClicked,
      additionalButton,
    } = this.props;
    return (
      <React.Fragment>
        <AuthConsumer>
          {({ user, accessRules }) => (
            <ThemeProvider theme={defaultTheme}>
              <Toolbar>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <div
                    style={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "start",
                      alignItems: "center",
                    }}
                  >
                    {menuButtonRender && (
                      <div
                        style={{
                          alignItems: "center",
                          flex: 0.1,
                        }}
                      >
                        {menuButtonRender}
                      </div>
                    )}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        textAlign: "start",
                        flex: 1,
                      }}
                    >
                      <Typography variant="h6" noWrap>
                        {title}
                      </Typography>
                    </div>
                    {this.hasPermission(buttonTitle, user, accessRules) && (
                      <div
                        style={{
                          flex: 0.2,
                          flexDirection: "row",
                          display: "flex",
                        }}
                      >
                        {HasMutablePermission({
                          role: user.role,
                          accessRules: accessRules,
                          perform: "company-employees:import",
                        }) &&
                          additionalButton && (
                            <div
                              style={{
                                display: "flex",
                                flex: 1,
                                justifyContent: "flex-end",
                              }}
                            >
                              <Fab
                                variant="extended"
                                style={{
                                  backgroundColor: "white",
                                  marginRight: 10,
                                }}
                                onClick={additionalButton.action}
                              >
                                <div className={classes.extendedIcon}>
                                  {additionalButton.icon}
                                </div>
                                {additionalButton.title}
                              </Fab>
                            </div>
                          )}
                        {onToolBarButtonClicked && (
                          <Fab
                            variant="extended"
                            style={{ backgroundColor: "white" }}
                            onClick={() => onToolBarButtonClicked()}
                          >
                            <AddIcon className={classes.extendedIcon} />
                            {buttonTitle}
                          </Fab>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </Toolbar>
            </ThemeProvider>
          )}
        </AuthConsumer>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(ToolBarComponent);
